export default __webpack_public_path__ + "static/media/instagram.f9d4dffb.svg";